// extracted by mini-css-extract-plugin
export var font = "Fonts-module--font--7pzzE";
export var selected = "Fonts-module--selected--u3bzP";